import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ReactSVG from 'react-svg';

export default class GridPopup extends React.PureComponent {
    state = {
        fields: this.props.fields
    };

    componentDidMount = () => {
        document.addEventListener('mousedown', this.handleClickOutside);
    };

    componentWillReceiveProps = nextProps => {
        if (nextProps.fields) {
            this.setState({ fields: nextProps.fields });
        }
    };

    componentWillUnmount = () => {
        document.removeEventListener('mousedown', this.handleClickOutside);
    };

    setWrapperRef = node => (this.wrapperRef = node);

    handleChange = event => {
        const { fields } = this.state;
        const { value, checked } = event.currentTarget;

        this.setState({ fields: {
                ...fields,
                [value]: {
                    ...fields[value],
                    hidden: !checked
                }
            } });
    };

    handleClickOutside = event => {
        if (!this.wrapperRef) return;
        if (this.wrapperRef.contains(event.target)) return;

        const { fields: stateFields } = this.state;
        const { handleClose, handleSaveChanges, fields: propsFields } = this.props;
        handleClose();
        // nothing changed, so no sense to call fields changes handler
        if (stateFields === propsFields) return;

        handleSaveChanges(stateFields);
    };

    render = () => {
        const { handleToggle, isOpen, t } = this.props;
        const { fields } = this.state;

        return (
            <div className="grid-col-popup-wrapper">
                <div className="grid-col-popup-button">
                    {/* <i className="icon-kebab-hor" onClick={handleToggle} /> */}
                    <div className="button-hover-half-circle" onClick={handleToggle}>
                        <ReactSVG
                            className="button-icon button-icon-fields-arrow"
                            src={`/data/svg/grid/fields_arrow.svg`}
                        />
                    </div>
                </div>
                {isOpen && (
                    <Fragment>
                        <div className="grid-col-popup" ref={this.setWrapperRef}>
                            {Object.entries(fields).map(([value, { name, hidden, permanent }]) => (
                                <div key={`grid-hide-${value}`}>
                                    <input
                                        id={`grid-hide-${value}`}
                                        type="checkbox"
                                        disabled={permanent}
                                        value={value}
                                        checked={!hidden}
                                        onChange={this.handleChange}
                                        hidden={!!name}
                                    />
                                    {name && (
                                        <label
                                            className={cx('grid-col-popup-column', { 'active': !hidden })}
                                            htmlFor={`grid-hide-${value}`}
                                        >
                                            {t(name)}
                                        </label>
                                    )}
                                </div>
                            ))}
                        </div>
                        {/* <div className="popup-window-overlay" /> */}
                    </Fragment>
                )}
            </div>
        );
    };
}

GridPopup.propTypes = {
    t: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    fields: PropTypes.object.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleToggle: PropTypes.func.isRequired,
    handleSaveChanges: PropTypes.func.isRequired
};
